<template>
    <div>
        <div class="is-flex is-align-items-center is-justify-content-space-between mb-2">
            <b>Статус кај курирот</b>
            <button type="button" class="button is-small is-light" :class="{'is-loading': loading}"
                    @click="fetchStatus">
                <span class="icon"><i class="fa fa-refresh"></i></span>
            </button>
        </div>
        <p class="help mb-2">Овој статус е одвоен од статусот на нарачката во системот.</p>

        <Loading variant="is-white" v-if="loading && !status"/>
        <div class="notification is-danger is-light py-2" v-else-if="error">{{ error }}</div>

        <div v-else-if="status">
            <div class="notification is-light py-2" v-if="!status.known">
                <b>ЕЛС не го препознава бројот за следење.</b>
                <br>
                <span v-if="status.reason">{{ status.reason }}</span>
            </div>

            <div class="notification py-2 mb-2" :class="status.current.code | elsStatusClass" v-if="status.current">
                <p class="heading mb-0">{{ status.shipping_type || "Тековен статус" }}</p>
                <p class="title is-5 mb-0">{{ status.current.text }}</p>
                <p class="heading mt-1 mb-0">{{ status.current.date }}</p>
            </div>

            <div class="els-timeline" v-if="status.history && status.history.length">
                <div class="els-timeline-item" v-for="(entry, index) in status.history" :key="index">
                    <span class="tag" :class="entry.code | elsStatusClass">{{ entry.text }}</span>
                    <span class="is-size-7 has-text-grey ml-2">{{ entry.date }}</span>
                </div>
            </div>

            <div class="tags mt-2">
                <span class="tag is-success" v-if="status.delivered">Доставено</span>
                <span class="tag is-danger" v-if="status.returned">Вратена пратка</span>
            </div>
        </div>

        <hr class="my-3">

        <button type="button" class="button is-small is-light is-fullwidth" :class="{'is-loading': detailsLoading}"
                @click="toggleDetails">
            {{ showDetails ? "Сокриј детали" : "Прикажи детали за пратката" }}
        </button>

        <div v-if="showDetails">
            <div class="notification is-danger is-light py-2 mt-2" v-if="detailsError">{{ detailsError }}</div>
            <table class="table is-fullwidth is-narrow is-size-7 mt-2 mb-0" v-else-if="detailRows.length">
                <tbody>
                <tr v-for="(row, index) in detailRows" :key="index">
                    <td class="has-text-grey">{{ row.label }}</td>
                    <td class="has-text-right">{{ row.value }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import Loading from "../../Loading";
    import {elsDetails, elsError, elsStatus} from "../../../api/els";

    const LABELS = {
        status: "Статус",
        weight: "Тежина",
        quantity: "Количина",
        price: "Цена",
        cod: "Откуп",
        recipient: "Примач",
        hub: "Хаб",
        courier: "Курир",
        payments: "Наплата",
        pickup: "Прием",
        delivery: "Достава",
        name: "Име",
        phone: "Телефон",
        address: "Адреса",
        place: "Место",
        text: "Текст",
        code: "Код",
        date: "Датум"
    };

    export default {
        name: "ElsStatus",
        components: {Loading},
        props: {
            orderId: {type: [Number, String], required: true}
        },
        data() {
            return {
                status: null,
                loading: false,
                error: null,
                details: null,
                detailsLoading: false,
                detailsError: null,
                showDetails: false
            }
        },
        computed: {
            detailRows() {
                return this.flatten(this.details);
            }
        },
        methods: {
            fetchStatus() {
                this.loading = true;
                this.error = null;
                elsStatus(this.orderId)
                    .then(data => {
                        this.status = data;
                        this.loading = false;
                    })
                    .catch(e => {
                        this.error = elsError(e);
                        this.loading = false;
                    });
            },
            toggleDetails() {
                this.showDetails = !this.showDetails;
                if (this.showDetails && !this.details) this.fetchDetails();
            },
            fetchDetails() {
                this.detailsLoading = true;
                this.detailsError = null;
                elsDetails(this.orderId)
                    .then(data => {
                        this.details = data;
                        this.detailsLoading = false;
                    })
                    .catch(e => {
                        this.detailsError = elsError(e);
                        this.detailsLoading = false;
                    });
            },
            // Вгнездените блокови (hub, courier, payments) се рамнат во редови етикета/вредност.
            flatten(obj, prefix) {
                if (!obj || typeof obj !== "object") return [];
                let rows = [];
                Object.keys(obj).forEach(key => {
                    const value = obj[key];
                    const label = prefix ? prefix + " · " + (LABELS[key] || key) : (LABELS[key] || key);
                    if (value && typeof value === "object") rows = rows.concat(this.flatten(value, label));
                    else rows.push({label: label, value: value === null || value === "" ? "—" : value});
                });
                return rows;
            }
        },
        created() {
            this.fetchStatus();
        }
    }
</script>

<style scoped>
    .els-timeline-item {
        border-left: 2px solid #dbdbdb;
        padding: 0.25rem 0 0.25rem 0.75rem;
    }
</style>
